var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 100 101",
    id: "size",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84,8.192l-4.494,4.494c-0.765,0.765 -2.007,0.765 -2.772,0c-0.765,-0.765 -0.765,-2.007 0,-2.772l7.84,-7.84c0.765,-0.766 2.007,-0.766 2.772,0l7.84,7.84c0.765,0.765 0.765,2.007 0,2.772c-0.765,0.765 -2.007,0.765 -2.772,0l-4.494,-4.494l0,79.548l79.548,0l-4.494,-4.494c-0.765,-0.765 -0.765,-2.007 0,-2.772c0.765,-0.765 2.007,-0.765 2.772,0l7.84,7.84c0.765,0.765 0.765,2.006 0,2.772l-7.84,7.84c-0.765,0.765 -2.007,0.765 -2.772,0c-0.765,-0.765 -0.765,-2.007 0,-2.772l4.494,-4.494l-79.548,0l0,5.88c0,1.082 -0.878,1.96 -1.96,1.96c-1.082,0 -1.96,-0.878 -1.96,-1.96l0,-5.88l-5.88,0c-1.082,0 -1.96,-0.878 -1.96,-1.96c0,-1.082 0.878,-1.96 1.96,-1.96l5.88,0l0,-79.548Zm72.557,14.831c0,-2.165 -1.755,-3.92 -3.92,-3.92l-54.954,0c-2.165,0 -3.92,1.755 -3.92,3.92l0,54.954c0,2.165 1.755,3.92 3.92,3.92l54.954,0c2.165,0 3.92,-1.755 3.92,-3.92l0,-54.954Z",
    fill: "#ffffff",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/Size.7e083c4b272f2ce4c9313d07d7592d17.svg";
export { ForwardRef as ReactComponent };